import { Link } from "react-router-dom";
import { Plus, User, LogOut } from "lucide-react";
import { ACCOUNT_LINKS } from "@/components/header/DesktopNav";

const rowCls = "flex items-center gap-2 px-4 py-3 border-b border-black text-black no-underline hover:bg-yellow-100 hover:no-underline";

export function MobileNav({ user, onClose, onLogout }) {
  return (
    <nav className="md:hidden border-t-2 border-black bg-white font-mono-data text-xs uppercase" data-testid="mobile-nav">
      <Link to="/post" onClick={onClose} data-testid="mobile-post-ad-btn" className="flex items-center gap-2 bg-[#0000EE] text-white px-4 py-3 border-b-2 border-black no-underline hover:no-underline">
        <Plus size={14} strokeWidth={3} /> Post Ad
      </Link>
      {user ? (
        <>
          {ACCOUNT_LINKS.map(({ to, label, icon: Icon, id }) => (
            <Link key={id} to={to} onClick={onClose} data-testid={`mobile-link-${id}`} className={rowCls}><Icon size={14} /> {label}</Link>
          ))}
          <button data-testid="mobile-logout-btn" onClick={() => { onClose(); onLogout(); }} className="w-full text-left flex items-center gap-2 px-4 py-3 text-[#FF0000] hover:bg-red-50"><LogOut size={14} /> Sign Out</button>
        </>
      ) : (
        <>
          <Link to="/login" onClick={onClose} data-testid="mobile-login-link" className={rowCls}><User size={14} /> Log In</Link>
          <Link to="/register" onClick={onClose} data-testid="mobile-register-link" className="flex items-center gap-2 px-4 py-3 bg-black text-white no-underline hover:no-underline"><Plus size={14} /> Sign Up</Link>
        </>
      )}
    </nav>
  );
}
